// extracted by mini-css-extract-plugin
module.exports = {"root":"LogoLink_root__1zdKw","logo":"LogoLink_logo__FdUME"};